import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import DefaultError from "../../common/core-ui/DefaultError.tsx";
import styles from "./InsetHomeError.module.scss";
import { useEffect } from "react";
import { noticeError } from "../../common/api/monitoring/index.ts";

export default function InsetHomeError() {
  const error = useRouteError();

  // Throw 401, etc up to root handler
  if (isRouteErrorResponse(error)) {
    throw error;
  }

  useEffect(() => {
    if (error instanceof Error) {
      noticeError(error);
    } else {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }, [error]);

  // Component error, show message inside frame
  return <DefaultError className={styles.error} />;
}
